import { useState } from 'react';
const usePrevNextNavigation = (items, selectedItem) => {
    const [currentItem, setCurrentItem] = useState(selectedItem);
    const onClickNavigation = (direction) => {
        const currentIndex = items.findIndex((item) => item.id === currentItem.id);
        const newIndex = direction === 'next'
            ? (currentIndex + 1) % items.length
            : (currentIndex - 1 + items.length) % items.length;
        setCurrentItem(items[newIndex]);
    };
    const prevItem = () => onClickNavigation('prev');
    const nextItem = () => onClickNavigation('next');
    return {
        onClickNavigation,
        setCurrentItem,
        prevItem,
        nextItem,
        currentItem,
    };
};
export default usePrevNextNavigation;
